/*
 * author gals
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var AutoLoginView = {};

    LE.module('LERegistration', function (LERegistration, LE, Backbone, Marionette) {
        var that;

        AutoLoginView = Marionette.ItemView.extend({

            withUIComponents: true,

            template: require("registration-templates/autoLoginView.tmpl"),

            className: 'auto-login-view',

            ui: {
                autoLoginForm: ".auto-login-form"
            },

            initialize: function (options) {
                that = this;
                this.model = options.model;
            },

            submitForm: function(){
                LERegistration.logger.info("RegistrationCreateAccountView >> doAutoLogin >> START");
                that.ui.autoLoginForm.submit();
                LERegistration.logger.info("RegistrationCreateAccountView >> doAutoLogin >> END");
            }

    });


    });

    return AutoLoginView;
});
 
 
